export const POSITION_ENUM = {
  TopCenter: 'top center',
  TopLeft: 'top left',
  TopRight: 'top right',
  BottomCenter: 'bottom center',
  BottomLeft: 'bottom left',
  BottomRight: 'bottom right',
  RightCenter: 'right center',
  LeftCenter: 'left center',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/PopUpPositionEnum.js